export default __webpack_public_path__ + "static/media/postsize.847544ce.png";